/**
 * Подстановка в строку словаря: «Скидка {amount} больше цены «{name}»».
 *
 * Строку целиком держит словарь, а не склейка кусков в коде: в казахском
 * порядок слов другой, и «до» + число + «после» в нём не собрать.
 * Незнакомый ключ остаётся как есть — опечатка в словаре видна глазом,
 * а не превращается в пустое место.
 */
export function fill(template: string, params: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) =>
    Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : match,
  );
}
